module.exports = __webpack_public_path__ + "static/img_4892-a3981a9b4afae0669bde40a8b9a6fc16.webp";